/* eslint-disable no-useless-catch */
import axios from "axios";

  module.exports.addTagToCompany = async (company_id, tag_id, tag_type) => {
    let addTag;
    try {
      addTag = await axios.post(
        "/api/v2/companies/" + company_id + "/tags",
        {
          tag_id: tag_id,
          relationType: tag_type,
        }
      );
    }catch(err){
        throw(err)
    }
    return addTag.data
}

module.exports.removeTagFromCompany = async (company_id, tag_id) => {
    let deleteTag = [];
        try {
          deleteTag = await axios.delete(
            `/api/v2/companies/${company_id}/tags` +
              "/" +
              tag_id
          );
        } catch (err) {
          throw(err)
        }
    return deleteTag.data
}
module.exports.getTagsForCompany = async (company_id) => {
    let tags;
    try {
      tags = await axios.get(
        "/api/v2/companies/" + company_id + "/tags"
      );
    } catch (error) {
        throw(error)
    }
    return tags.data
}
module.exports.getTagsByNames = async (names) => {
    let tags;
    try {
        tags = await axios.get(`/api/v2/tags?names=${names.join(',')}`);
    } catch (error) {
    throw error;
    }
    return tags.data
}
module.exports.getTagsByType = async (type) => {
  let tags;
  try {
      tags = await axios.get(`/api/v2/tags?tag_type=${type}`);
  } catch (error) {
  throw error;
  }

  return tags.data
}